import React from 'react';
import { CustomSelect } from 'components';
import { useFeatureSpreadsheet } from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { toString } from 'utilities';
import { VolatilitySourceProps } from './VolatilitySource.props';

const VolatilitySource = ({ cell, options, ...restProps }: VolatilitySourceProps) => {
  const { onCommit, onRevert } = restProps;
  const { onCellsChanged } = useFeatureSpreadsheet();

  const handleChange = (value: string | null) => {
    const newValue = value !== null ? toString(value) : null;
    onCellsChanged([{ cell, value: newValue }]);
  };

  return (
    <CustomSelect
      id={`volatility-source-${cell.key}`}
      options={options}
      value={cell.value as string}
      onChange={handleChange}
      onCommit={(value: string | null) => onCommit?.(value ?? '')}
      onRevert={onRevert}
      disabled={cell.readOnly}
      onEmptyValue=""
    />
  )
}

export default VolatilitySource;
